module.exports = (state, action) => {
  const { signature } = action.payload
  state.me.preferences.signature = signature
}
